/**
 * API route constants for ecommerce module.
 * These are kept separate from the route implementations to avoid
 * bundling server-only dependencies (like Cloudflare Browser Rendering) into client code.
 */

/** API route path for generating proposal PDFs using Cloudflare Browser Rendering */
export const PROPOSAL_GENERATE_PDF_API_ROUTE =
    '/remix-api/proposal/generate-pdf';
